import { useLocation, useNavigate } from 'react-router-dom';
import { NavigationIconProps } from './navigation-icon.component';

interface ViewProps {
    onNavigate: () => void;
    highlighted: boolean;
}

const useNavigationIcon = (props: NavigationIconProps): ViewProps => {
    const navigate = useNavigate();
    const location = useLocation();

    const onNavigate = () => {
        if (props.disabled) return;
        navigate(`/${props.link}`);
    };

    return {
        onNavigate,
        highlighted: location.pathname.includes(props.link)
    };
};

export default useNavigationIcon;
